import React from 'react'
import { AppContext } from "contexts/AppContext";
import { useContext, useState } from 'react'
import RegisterForm from './RegisterForm'
import RegisterSuccess from './RegisterSuccess'
import RegisterError from './RegisterError'
import "./Register.css"
import RegisterCreated from './RegisterCreated';
import RegisterPageBanner1 from 'components/blocks/registerPageBanner/RegisterPageBanner1';
import { Box, Grid2 as Grid } from '@mui/material';
import SectionWrapper from 'components/layouts/SectionWrapper';
import ContentNormal from 'components/elements/ContentNormal';
import Headline4 from 'components/elements/Headline4';

const Register = () => {
    const { brandData, langCode, styleGuide } = useContext(AppContext);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    let brandSlug = brandData && brandData.brandSlug;
    const automaticApproval = brandData?.features?.registerUser?.automaticApproval
    
    let {frontPageBannerContent, frontPageBannerTitle, frontPageTextColorBlack}= brandData && brandData.features
    return (
        <div>
            <Grid size={12}>
                <RegisterPageBanner1
                    title={frontPageBannerTitle && typeof frontPageBannerTitle === 'object' ?
                        frontPageBannerTitle.hasOwnProperty(langCode) ? frontPageBannerTitle[langCode] : '' : frontPageBannerTitle ? frontPageBannerTitle : ''}
                    text={frontPageBannerContent && typeof frontPageBannerContent === 'object' ?
                        frontPageBannerContent.hasOwnProperty(langCode) ?  frontPageBannerContent[langCode] : '' : frontPageBannerContent ? frontPageBannerContent : ''}
                    textColor={!!frontPageTextColorBlack ? styleGuide.color18 : styleGuide.color1}
                />
            </Grid>
            <SectionWrapper>
                <Box display={'flex'} flexWrap={'wrap'} paddingTop={10} columnGap={10}>
                    <Box flex={1}>
                        <Grid
                            size={12}
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            >
                            <Grid item xs={12} sm={6} >
                                    {!success && !error && <RegisterForm setError={setError} setSuccess={setSuccess} />}
                                    {success && !automaticApproval && <RegisterSuccess />}
                                    {success && !!automaticApproval && <RegisterCreated />}
                                    {error && <RegisterError
                                    errorMessage='Du er allerede oprettet i klubben.'
                                    subMessage={`Venligst log ind på <a class='link' href='http://${brandSlug}.upgrader.club'>${brandSlug}.upgrader.club</a>`}/>}
                            </Grid>
                        </Grid>
                    </Box>

                    <Box flex={1} display={'flex'} flexDirection={'column'} gap={2} minWidth={320} paddingBottom={10}>

                        <Box display={'flex'} alignItems={'center'} gap={4}>
                            <Box display={'flex'} flexDirection={'column'} gap={1}>
                                <Headline4
                                    translationKey="_CONTACT_INFORMATION_"
                                    fallbackText="Kontakt information"
                                />
                                {!!brandData?.features?.registerUser?.contactPersonName &&
                                    <ContentNormal style={{fontWeight: 500}}>
                                        {brandData?.features?.registerUser?.contactPersonName}
                                    </ContentNormal>
                                }

                                {!!brandData?.contactEmail &&
                                    <ContentNormal style={{fontWeight: 500}}>
                                        {brandData.contactEmail}
                                    </ContentNormal>
                                }

                                {!!brandData?.contactPhone &&
                                    <ContentNormal style={{fontWeight: 500}}>
                                        {brandData.contactPhone}
                                    </ContentNormal>
                                }
                            </Box>

                            <Box>
                                {!!brandData?.features?.registerUser?.contactPersonImageUrl &&
                                    <img src={brandData?.features?.registerUser?.contactPersonImageUrl} width={120} height={120} />
                                }
                            </Box>
                        </Box>


                    </Box>
                </Box>
            </SectionWrapper>
            
        </div>
    )
}

export default Register